module.exports = __webpack_public_path__ + "img/1.dd8ed3de.jpg";